import { render, staticRenderFns } from "./TagProductIds.vue?vue&type=template&id=493d13aa&"
import script from "./TagProductIds.vue?vue&type=script&lang=ts&"
export * from "./TagProductIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports